var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#70b246;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-4{fill:#f4e211;}.cls-5{fill:#2ca0ff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M995.47,595.89c31.64-3.24,66.94-.16,89.55,22.2,29,28.62,24.23,80.07-2.36,110.9s-68.83,43.88-109.47,46.36-81.24-4.13-121.93-5.47c-41.37-1.36-84.08,3.59-119.44,26.67,20-15.29,27-43.28,40.7-63.9a310.66,310.66,0,0,1,59.54-66.33C878.18,627.71,935.47,602.05,995.47,595.89Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flower_3",
    "data-name": "flower 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M632,789.62c-7.26,44.35-14.51,89.91-5.35,133.9,5.83,28,22.73,58.15,51.07,62.32,18.09,2.65,36.39-6.54,48.77-20s19.74-30.72,25.85-48A472.33,472.33,0,0,0,763.94,642c-6.52-24.85-17.54-53.18-39.19-68.77-18.2-13.11-46.83-18.26-58.17,4.72-11.89,24.13-10.43,64.24-14.73,90.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M995.47,595.89c31.64-3.24,66.94-.16,89.55,22.2,29,28.62,24.23,80.07-2.36,110.9s-68.83,43.88-109.47,46.36-81.24-4.13-121.93-5.47c-41.37-1.36-84.08,3.59-119.44,26.67,20-15.29,27-43.28,40.7-63.9a310.66,310.66,0,0,1,59.54-66.33C878.18,627.71,935.47,602.05,995.47,595.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M841.35,714s80.71-71.18,231.13-41.07"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M505.23,38.22c16.31-8.52,38.83-1.81,47.83,14.24s2.94,38.77-12.85,48.23-38.67,4.07-48.58-11.43-5.2-38.53,10-48.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M817.29,70.11c5.3,22.57-10.2,47.93-32.7,53.51s-48.05-9.58-53.92-32C716,35.48,804,13.62,817.29,70.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M479.33,452c26.82,74.15,82.29,142.34,158.13,164,62.89,17.93,133.06,1,185.52-38.08s87.86-98.36,104.9-161.5,16.65-130,6.69-194.67c-3.78-24.51-9.38-49.84-25-69.1s-44-30.28-66.05-18.95c-17.28,8.88-26.19,28.48-30.69,47.39s-6,38.79-14.24,56.38-26.1,32.83-45.33,30.06c-22.64-3.26-34.94-28.64-37.82-51.32s-.6-46.91-11.13-67.21c-10.86-21-35.47-33.88-58.89-30.94S601.36,139.55,596,162.55c-4.33,18.59.67,38.09-1.08,57.1s-15.11,40.15-34.14,38.63c-16.24-1.29-26.55-18.31-30.1-34.2s-3.37-33.07-11.36-47.27c-12.58-22.36-45.92-29.54-66.6-14.35-17.67,13-20.58,36.63-14.73,56.34,6.64,22.37,10.81,38.76,12.05,63.06C453,339.42,459.61,397.49,479.33,452Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 651.85,
    y1: 668.41,
    x2: 624.06,
    y2: 846.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M764,880s-26.07,113.38-86.23,105.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects27);
export default __webpack_public_path__ + "static/media/objects-27.8e9900e3d16a2fc50ffd8dac6647891b.svg";
export { ForwardRef as ReactComponent };